import React from 'react'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'


const DefaultLoading = (props) => {
    const {inProgress} = props
    return (
        // @ts-ignore
        <ReactPlaceholder type='text' rows={7} ready={!inProgress} showLoadingAnimation />
    )
}

export default DefaultLoading
